import actions from '../../redux/actions';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import React, {useEffect, useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';
import CustomInput from '../../common/components/CustomInput/CustomInput';
import Search from '../../assets/icons/Search';
import Button from '../../common/components/Button/Button';
import Table from '../../common/components/ItemTable/v2/Table';
import Loading from '../../common/components/Loading/Loading';
import CustomAlert from '../../common/components/Alert/CustomAlert';
import Trash from '../../assets/icons/Trash';
import Lock from '../../assets/icons/Lock';
import _Modal from '../../common/components/Modal/v2/Modal';
import {Tooltip} from '@mui/material';


const _Administrators = (props) => {
    const {
        name,
        columnDataAdmin,
        deleteAdmin,
        getUsers,
        users,
        getUsersState,
        adminListConfig,
        setListConfig,
        switchOfUser,
        resetPassEmail,
        userInfo,
        cleanListConfig,
        showSidebar,
    } = props;

    const [columnName, setColumnName] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalText, setModalText] = useState('');
    const [modalButtonAction, setModalButtonAction] = useState(null);
    const [modalInfo, setModalInfo] = useState(null);
    const totalUsers = users?.total
    const [currentPage, setCurrentPage] = useState(-1);
    const [pageQuantity, setPageQuantity] = useState(10); // todo: hardcoded
    const history = useHistory();

    const [search, setSearch] = useState('');


    const pushPage = (name) => {
        history.push(name);
    };

    const adminTableHeader = [
        {id: 'email', att: 'email', title: 'Correo electrónico'},
        {id: 'firstName', att: 'firstName', title: 'Nombre'},
        {id: 'lastName', att: 'lastName', title: 'Apellido'},
        {id: 'trash', flex: 0.5, align: 'right', sortable: false, renderCell: (params) => adminButtons(params.row)},
    ];

    const isInitialMount = useRef(true);

    useEffect(() => {
        if (!isInitialMount.current) {
            setListConfig({
                list: 'adminListConfig',
                config: {page: currentPage},
            });
            getUsers();
        }
        isInitialMount.current = false;
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect(() => {
        if (currentPage > pageQuantity) setCurrentPage(pageQuantity);
        // eslint-disable-next-line
    }, [users]);

    useEffect(() => {
        switchOfUser('Administradores');
        cleanListConfig('adminListConfig');
        setCurrentPage(adminListConfig?.page ?? -1);
        // eslint-disable-next-line
    }, []);

    const handleSearch = () => {
        setListConfig({
            list: 'adminListConfig',
            config: {search: search, page: 1},
        });
        getUsers();
    };

    const handleClickDelete = (admin) => {
        deleteAdmin(admin.id);
        handleClose();
    };

    const handleDelete = (data) => {
        setModalInfo({
            title: 'Eliminar administrador',
            text: '¿Seguro que desea eliminar a este administrador?',
            buttonAction: () => handleClickDelete(data),
            buttonText: 'Eliminar',
            handleClose: handleClose,
        });
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
    };

    const handleResetPass = (data) => {
        setModalInfo({
            title: 'Restablecer contraseña',
            text: '¿Seguro que desea restablecer la contraseña del administrador?',
            buttonAction: () => handleClickResetPass(data),
            buttonText: 'Restablecer',
            handleClose: handleClose,
        });
        setShowModal(true);
    };

    const adminButtons = (data) => {
        return (
            <div className={'flex-aligned-justified-center gap-16'}>
                {data.id !== userInfo.id &&
                    <Tooltip title={'Eliminar'}>
                        <div className={'cursor-pointer'} onClick={() => handleDelete(data)}>
                            <Trash width={'14px'} height={'14px'}/>
                        </div>
                    </Tooltip>
                }
                <Tooltip title={'Cambiar contraseña'}>
                    <div className={'cursor-pointer'} onClick={() => handleResetPass(data)}>
                        <Lock width={'14px'} height={'14px'}/>
                    </div>
                </Tooltip>
            </div>
        );
    };

    const handleClickResetPass = (data) => {
        if (data.email === userInfo.email) {
            handleClose();
            history.push('/change_password');
        } else {
            resetPassEmail({email: data.email});
            handleClose();
        }
    };

    return (
        <div className={'page-content-container'}>
            <p className={'h3 v2-c-text-title'}>Administradores</p>
            <div className={'page-table-container'}>
                <div className="page-table-options">
                    <div className={'filter-container'}>
                        <form onSubmit={(event) => {
                            handleSearch();
                            event.preventDefault();
                        }}>
                            <CustomInput placeholder={`Buscar administrador...`}
                                         value={search}
                                         onChange={(e) => setSearch(e.replace(/[^@\w\s.]/gi, ''))}
                                         leftSlot={<Search/>}
                            />
                        </form>
                    </div>
                    <Button size={'small'} onClick={() => pushPage('/v1/admin/add')}>Crear</Button>
                </div>
                <div style={{height: '500px'}}>
                    {getUsersState?.success ?
                        <Table attributes={adminTableHeader} rows={users?.results} currentPage={currentPage}
                               onPageChange={(value) => setCurrentPage(value)} rowCount={totalUsers}
                               pageSize={pageQuantity}/> :
                        getUsersState?.loading ? <Loading className="ul-div-sect-table"/> :
                            <CustomAlert text={'administradores' || String(getUsersState.error)} severity='error'/>
                    }
                </div>
                {showModal && (
                    <_Modal
                        showModal={showModal}
                        handleClose={modalInfo?.handleClose}
                        handleClick={modalInfo?.buttonAction}
                        modalTitle={modalInfo?.title}
                        modalButtonText={modalInfo?.buttonText}
                        modalText={modalInfo?.text}
                    />
                )}
            </div>
        </div>

    );
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    columnDataAdmin: state.home.columnDataAdmin,
    users: state.home.users,
    getUsersState: state.home.getUsersState,
    adminListConfig: state.home.adminListConfig,
    userInfo: state.login.userInfo,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    getUsers: () => dispatch(actions.home.getUsersRequest()),
    setListConfig: (body) => dispatch(actions.home.setListConfig(body)),
    deleteAdmin: (id) => dispatch(actions.home.deleteAdminRequest(id)),
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    cleanUsers: () => dispatch(actions.home.cleanUsers()),
    resetPassEmail: (body) => dispatch(actions.login.resetPassEmailRequest(body)),
    cleanListConfig: (list) => dispatch(actions.home.cleanListConfig(list)),
});

_Administrators.propTypes = {
    name: PropTypes.string,
    columnDataAdmin: PropTypes.object,
    getUsers: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(_Administrators);
